// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { ReactComponent as Boost } from '../../assets/svg/Boost.svg';
import { SportIconsBySportId, MultimatchSportIconsBySportId } from '../../constants/ui/icons';
import { SportIds } from '../../types/sports';

const Icon = styled.div`
  height: 2em;
  width: 2em;
  background-image: ${({ $imgPath }) => `url(${$imgPath})`};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 50% 50%;
  background-color: transparent;
`;

type PropsType = {
  className?: string;
  sportId?: number;
  isMultimatch?: boolean;
};

const SportIcon = ({ className, sportId, isMultimatch }: PropsType) => {
  const imgPath = useMemo(() => {
    if (isMultimatch && MultimatchSportIconsBySportId[sportId]) {
      return MultimatchSportIconsBySportId[sportId];
    }
    return SportIconsBySportId[sportId];
  }, [isMultimatch, sportId]);

  if (sportId === SportIds.SPECIAL_ODDS) {
    return <Boost className={className} />;
  }
  return <Icon className={className} $imgPath={imgPath} />;
};

export default SportIcon;
